import type { Field } from 'payload'

/**
 * Цвет плашки для блоков страницы. «Смелые заливки» — часть фирменного
 * стиля, поэтому выбор цвета живёт в CMS, а не только в коде.
 */
export const BACKGROUNDS = [
  { value: 'sand', label: 'Песок (фон сайта)' },
  { value: 'tangerine', label: 'Апельсин — оранжевый' },
  { value: 'deep', label: 'Глубокий синий' },
  { value: 'sun', label: 'Солнце — жёлтый' },
  { value: 'punch', label: 'Фуксия' },
  { value: 'foam', label: 'Пена — очень светлая бирюза' },
  { value: 'lagoon', label: 'Лагуна — светлая бирюза' },
  { value: 'sea', label: 'Вода — бирюзовый' },
  { value: 'ink', label: 'Чёрный' },
] as const

export type Background = (typeof BACKGROUNDS)[number]['value']

/** Классы фона и текста для каждой плашки. Тёмные заливки — светлый текст. */
export const backgroundClasses: Record<Background, string> = {
  sand: 'bg-sand text-ink',
  tangerine: 'bg-tangerine text-ink',
  deep: 'bg-deep text-sand',
  sun: 'bg-sun text-ink',
  punch: 'bg-punch text-white',
  foam: 'bg-foam text-ink',
  lagoon: 'bg-lagoon text-ink',
  sea: 'bg-sea text-sand',
  ink: 'bg-ink text-sand',
}

/** На этих заливках текст светлый — блоки спрашивают отсюда, а не помнят список сами. */
export const DARK_BACKGROUNDS: Background[] = ['punch', 'sea', 'deep', 'ink']

export const isDarkBackground = (bg?: string | null): boolean => DARK_BACKGROUNDS.includes(bg as Background)

export const backgroundField = (defaultValue: Background = 'sand'): Field => ({
  name: 'background',
  type: 'select',
  label: 'Фон блока',
  defaultValue,
  options: [...BACKGROUNDS],
  admin: { position: 'sidebar' },
})
